module.exports = __webpack_public_path__ + "img/icon_setting_b.9a53ed5f.svg";